/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    CommunityRankingRecord,
    CommunityRankingRecordFromJSON,
    CommunityRankingRecordFromJSONTyped,
    CommunityRankingRecordToJSON,
} from './';

/**
 * 
 * @export
 * @interface GetCommunityRankingDataResponse
 */
export interface GetCommunityRankingDataResponse {
    /**
     * 
     * @type {Array<CommunityRankingRecord>}
     * @memberof GetCommunityRankingDataResponse
     */
    communityRankingRecords: Array<CommunityRankingRecord>;
}

export function GetCommunityRankingDataResponseFromJSON(json: any): GetCommunityRankingDataResponse {
    return GetCommunityRankingDataResponseFromJSONTyped(json, false);
}

export function GetCommunityRankingDataResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetCommunityRankingDataResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'communityRankingRecords': ((json['communityRankingRecords'] as Array<any>).map(CommunityRankingRecordFromJSON)),
    };
}

export function GetCommunityRankingDataResponseToJSON(value?: GetCommunityRankingDataResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'communityRankingRecords': ((value.communityRankingRecords as Array<any>).map(CommunityRankingRecordToJSON)),
    };
}


